import DomainCommon from './common';

const SpecialistService = {
    getAvailableWorkTime: ({ division, medical, from, to, past }) => {
        const params = { division, medical, from, to, past }
        return new Promise((resolve, reject) => {
            return DomainCommon.fetch({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/specialist/workTime?${DomainCommon.buildQueryString(params)}`,
                resolve, reject,
            })
        })
    },
    getAvailableWorkTimeByAdminMedical: ({ division, medical, from, to, past }) => {
        const params = { division, medical, from, to, past: true}
        return new Promise((resolve, reject) => {
            return DomainCommon.fetch({
                url: `${DomainCommon.getUecareApiUrl()}/ui/adminMedical/specialist/workTime?${DomainCommon.buildQueryString(params)}`,
                resolve, reject,
            })
        })
    },
}

export default SpecialistService



// WEBPACK FOOTER //
// ./src/service/specialist.js